import { memo, type PointerEvent } from 'react'
import type { SearchLayout } from '../search/layoutPreference'
import { Icon } from './Icon'

interface SearchLayoutSelectorProps {
  layout: SearchLayout
  onChange: (layout: SearchLayout) => void
}

function preserveOpenTouchKeyboard(event: PointerEvent<HTMLButtonElement>): void {
  if (document.documentElement.dataset.visualViewportKeyboard === 'open') {
    event.preventDefault()
  }
}

export const SearchLayoutSelector = memo(function SearchLayoutSelector({
  layout,
  onChange,
}: SearchLayoutSelectorProps) {
  return (
    <span className="join icon-choice-group search-layout-selector" role="group" aria-label="Result layout">
      <button
        className="btn btn-ghost btn-square join-item icon-choice-group__option"
        type="button"
        aria-label="Minimal text previews"
        title="Minimal text previews"
        aria-pressed={layout === 'minimal'}
        onPointerDown={preserveOpenTouchKeyboard}
        onClick={() => onChange('minimal')}
      >
        <Icon name="layout-minimal" />
      </button>
      <button
        className="btn btn-ghost btn-square join-item icon-choice-group__option"
        type="button"
        aria-label="Compact previews"
        title="Compact previews"
        aria-pressed={layout === 'compact'}
        onPointerDown={preserveOpenTouchKeyboard}
        onClick={() => onChange('compact')}
      >
        <Icon name="layout-grid" />
      </button>
      <button
        className="btn btn-ghost btn-square join-item icon-choice-group__option search-layout-selector__option--detailed"
        type="button"
        aria-label="Detailed large previews"
        title="Detailed large previews"
        aria-pressed={layout === 'detailed'}
        onPointerDown={preserveOpenTouchKeyboard}
        onClick={() => onChange('detailed')}
      >
        <Icon name="layout-cards" />
      </button>
    </span>
  )
})
